/* globals Emails */

window['emails#new'] = function () {
  Emails.initForm()
  Emails.initFollowUp()
}
